import React from 'react';
import { NavigationMenu, Provider, RoutePropagator } from '@shopify/app-bridge-react';
import { AppProvider, Frame, Spinner } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { Outlet, useLocation } from 'react-router-dom';
import { config_variable } from '../helper/commonApi';
import { useSelector } from 'react-redux';
import NotFound from '../pages/NotFound';
import { isAdmin } from '../utils/constant';
import { FormikProvider } from '../contexts/FormikContext';
import MainPage from '../pages/Main';
import ActivityLogPage from '../pages/Log';
import GeoBlockingPage from '../pages/GeoBlocking';
import SettingsPage from '../pages/Setting';
import FaqPage from '../pages/Faq';
import PricingPage from '../pages/PricingPage';
import RedirectPreventionPage from '../pages/RedirectPrevention';
import OnboardingPage from '../pages/Onboarding';
import SecurityReviewPage from '../pages/SecurityReview';

export function Router() {
    const { status, settings, isGetSettingLoading } = useSelector(
        (store) => store.commonData
    );
    const location = useLocation();

    if (!config_variable.config.host) {
        config_variable.config.host = location?.state?.config?.host ? location?.state?.config?.host : config_variable.config.host;
        config_variable.shop_name = location?.state?.shop_name ? location?.state?.shop_name : config_variable.shop_name;
    }

    if (!status || isGetSettingLoading) {
        return <div style={{ textAlign: "center", paddingTop: "20%" }}>
            <Spinner accessibilityLabel="Spinner example" size="large" />
        </div>
    }

    // Check if onboarding is completed
    const isOnboardingCompleted = settings?.onboarding?.is_completed === true;
    const showOnboarding = !isOnboardingCompleted && location.pathname !== '/onboarding';

    return (
        <>
            <AppProvider i18n={enTranslations}>
                {isAdmin ?
                    <FormikProvider initialData={settings}>
                        <Provider config={config_variable.config}>
                            {!isOnboardingCompleted && (
                                <NavigationMenu
                                    navigationLinks={[]}
                                    matcher={(link, location) => link.destination === location.pathname} />
                            )}
                            {isOnboardingCompleted && (
                                <NavigationMenu
                                    navigationLinks={isAdmin ? [
                                        {
                                            label: "Protection Setting",
                                            destination: "/setting"
                                        },
                                        {
                                            label: "Activity Log",
                                            destination: "/activity-log"
                                        },
                                        {
                                            label: "Geo Blocking",
                                            destination: "/geo-blocking"
                                        },
                                        {
                                            label: "Redirect Prevention",
                                            destination: "/redirect-prevention"
                                        },
                                        {
                                            label: "FAQ",
                                            destination: "/faq"
                                        },
                                        // {
                                        //     label: "Pricing Plans",
                                        //     destination: "/pricing"
                                        // },
                                        {
                                            label: "Security Review",
                                            destination: "/security-review"
                                        }
                                    ] : []}
                                    matcher={(link, location) => link.destination === location.pathname} />
                            )}
                            <Frame>
                                <RoutePropagator location={location} />
                                {showOnboarding ? <OnboardingPage /> : <Outlet />}
                            </Frame>
                        </Provider>
                    </FormikProvider> :
                    <Outlet />
                }
            </AppProvider>
        </>
    );
}

export const routes = [
    { path: '/onboarding', component: <OnboardingPage /> },
    { path: '/', component: <MainPage /> },
    { path: '/setting', component: <SettingsPage /> },
    { path: '/activity-log', component: <ActivityLogPage /> },
    { path: '/geo-blocking', component: <GeoBlockingPage /> },
    { path: '/redirect-prevention', component: <RedirectPreventionPage /> },
    { path: '/faq', component: <FaqPage /> },
    { path: '/pricing', component: <PricingPage /> },
    { path: '/security-review', component: <SecurityReviewPage /> },
    { path: '*', component: <NotFound /> },
];
